import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminSubscriptions() {
  const [subs, setSubs] = useState([]);
  const [filter, setFilter] = useState('pending');
  const [billModal, setBillModal] = useState(null);

  const load = () => API.get('/admin/subscriptions').then(r => setSubs(r.data));
  useEffect(() => { load(); }, []);

  const approve = async id => {
    await API.post(`/admin/subscriptions/${id}/approve`);
    toast.success('✅ Subscription approved!'); load();
  };
  const reject = async id => {
    await API.post(`/admin/subscriptions/${id}/reject`);
    toast.success('❌ Subscription rejected'); load();
  };
  const loadBill = async id => {
    const r = await API.get(`/admin/subscriptions/${id}/bill`);
    setBillModal(r.data);
  };

  const filtered = subs.filter(s => filter === 'all' || s.status === filter);
  const statusBadge = { pending: 'badge-warning', active: 'badge-success', rejected: 'badge-danger', expired: 'badge-info' };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 20px' }}>
        <div className="page-header flex-between">
          <div><h1>💳 Subscriptions</h1><p>Review and manage subscription requests</p></div>
          <select value={filter} onChange={e => setFilter(e.target.value)} style={{ width: 160 }}>
            <option value="pending">⏳ Pending</option>
            <option value="active">✅ Active</option>
            <option value="rejected">❌ Rejected</option>
            <option value="all">📋 All</option>
          </select>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {filtered.map(s => (
            <div key={s.id} className="card">
              <div className="flex-between" style={{ flexWrap: 'wrap', gap: 12 }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 16 }}>{s.full_name}</div>
                  <div style={{ color: 'var(--text2)', fontSize: 13 }}>📞 {s.phone} • {s.role?.replace('_', ' ')}</div>
                  <div style={{ color: 'var(--text2)', fontSize: 13, marginTop: 4 }}>
                    Plan: <strong>{s.plan_name}</strong> • Exams: {s.exam_limit}
                    {s.start_date && <> • {new Date(s.start_date).toLocaleDateString()} → {new Date(s.end_date).toLocaleDateString()}</>}
                  </div>
                  {s.payment_note && <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4 }}>Note: {s.payment_note}</div>}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  <span className={`badge ${statusBadge[s.status] || 'badge-info'}`}>{s.status?.toUpperCase()}</span>
                  {s.payment_screenshot && (
                    <a href={s.payment_screenshot} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm">🖼️ Screenshot</a>
                  )}
                  <button onClick={() => loadBill(s.id)} className="btn btn-secondary btn-sm">🧾 Bill</button>
                  {s.status === 'pending' && <>
                    <button onClick={() => approve(s.id)} className="btn btn-success btn-sm">✅ Approve</button>
                    <button onClick={() => reject(s.id)} className="btn btn-danger btn-sm">❌ Reject</button>
                  </>}
                </div>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <div className="card text-center text-muted">No subscriptions found</div>}
        </div>
      </div>

      {billModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>🧾 Bill / Invoice</h2>
            <div style={{ background: 'var(--card2)', borderRadius: 12, padding: 20, marginBottom: 20 }}>
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                <div style={{ fontWeight: 800, fontSize: 22, color: 'var(--primary-light)' }}>{billModal.settings.brand_name}</div>
                <div style={{ color: 'var(--text2)', fontSize: 13 }}>{billModal.settings.tagline}</div>
              </div>
              <hr className="divider" />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14 }}>
                <div className="flex-between"><span className="text-muted">Subscriber</span><strong>{billModal.sub.full_name}</strong></div>
                <div className="flex-between"><span className="text-muted">Phone</span><span>{billModal.sub.phone}</span></div>
                <div className="flex-between"><span className="text-muted">Plan</span><strong>{billModal.sub.plan_name}</strong></div>
                <div className="flex-between"><span className="text-muted">Exams Allowed</span><span>{billModal.sub.exam_limit}</span></div>
                {billModal.sub.start_date && <div className="flex-between"><span className="text-muted">Valid From</span><span>{new Date(billModal.sub.start_date).toLocaleDateString()}</span></div>}
                {billModal.sub.end_date && <div className="flex-between"><span className="text-muted">Valid To</span><span>{new Date(billModal.sub.end_date).toLocaleDateString()}</span></div>}
                <hr className="divider" />
                <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--text3)' }}>{billModal.settings.brand_name} • {billModal.settings.tagline}</div>
              </div>
            </div>
            <button className="btn btn-secondary btn-full" onClick={() => setBillModal(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
